import script from "./RemindersPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RemindersPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__